<div class="container">
  <i class="material-icons">check_circle</i>

  <div class="title">{{ title }}</div>
  <div class="message">{{ message }}</div>
</div>
